/* Dante Furniture — Collection card image carousel
   Features:
      - Prev/Next arrows
   - Dots navigation
   - Swipe on touch devices
   - Prevents navigation when interacting (cards are wrapped in <a>)
*/
(function(){
  function getActiveIndex(slides){
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function setActive(mediaEl, index){
    if(!mediaEl) return;
    var slides = mediaEl.querySelectorAll('.df-card__slide');
    if(!slides || slides.length < 2) return;

    var dots = mediaEl.querySelectorAll('.df-card__dot');
    var max = slides.length;
    var nextIndex = ((index % max) + max) % max;

    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('is-active', i === nextIndex);
      if (dots[i]) dots[i].classList.toggle('is-active', i === nextIndex);
    }
  }

  function goNext(mediaEl){
    var slides = mediaEl.querySelectorAll('.df-card__slide');
    setActive(mediaEl, getActiveIndex(slides) + 1);
  }

  function goPrev(mediaEl){
    var slides = mediaEl.querySelectorAll('.df-card__slide');
    setActive(mediaEl, getActiveIndex(slides) - 1);
  }

  // Click handling: arrows + dots + image area
  document.addEventListener('click', function(e){
    var arrow = e.target.closest('[data-df-carousel]');
    var dot = e.target.closest('[data-df-dot]');
    var media = e.target.closest('[data-df-carousel-media]');

    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      var mediaEl = arrow.closest('.df-card__media');
      if (!mediaEl) return;
      var dir = arrow.getAttribute('data-df-carousel');
      if (dir === 'prev') goPrev(mediaEl);
      else goNext(mediaEl);
      return;
    }

    if (dot) {
      e.preventDefault();
      e.stopPropagation();
      var mediaEl2 = dot.closest('.df-card__media');
      if (!mediaEl2) return;
      var idx = parseInt(dot.getAttribute('data-df-dot'), 10);
      if (!isNaN(idx)) setActive(mediaEl2, idx);
      return;
    }
  }, { passive: false });

  // Swipe support
  function attachSwipe(mediaEl){
    if (!mediaEl || mediaEl.__dfSwipeBound) return;
    mediaEl.__dfSwipeBound = true;

    var startX = 0;
    var startY = 0;
    var tracking = false;

    mediaEl.addEventListener('touchstart', function(ev){
      if (!ev.touches || ev.touches.length !== 1) return;
      var slides = mediaEl.querySelectorAll('.df-card__slide');
      if (!slides || slides.length < 2) return;
      tracking = true;
      startX = ev.touches[0].clientX;
      startY = ev.touches[0].clientY;
    }, { passive: true });

    mediaEl.addEventListener('touchend', function(ev){
      if (!tracking) return;
      tracking = false;
      if (!ev.changedTouches || ev.changedTouches.length !== 1) return;
      var endX = ev.changedTouches[0].clientX;
      var endY = ev.changedTouches[0].clientY;
      var dx = endX - startX;
      var dy = endY - startY;

      // Horizontal swipe threshold
      if (Math.abs(dx) < 35 || Math.abs(dx) < Math.abs(dy)) return;

      // Prevent link navigation on swipe
      ev.preventDefault();
      ev.stopPropagation();
      if (dx < 0) goNext(mediaEl);
      else goPrev(mediaEl);
    }, { passive: false });
  }

  function init(){
    var medias = document.querySelectorAll('[data-df-carousel-media]');
    for (var i = 0; i < medias.length; i++) attachSwipe(medias[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
